import { Model_ConfigurationQueryAttributValueFilterPost, Model_ConfigurationQueryFilterPost, Model_ConfigurationQueryLabelFilterPost } from "src/backend/openapi/v1";

export type TAttributeOptionsType = Model_ConfigurationQueryAttributValueFilterPost;
export type TLabelOptionsType = Model_ConfigurationQueryLabelFilterPost;

export type TAppliedFilterChip = {
  attributeId?: string;
  attributeName?: string;
  valueId: string;
  valueDescription: string;
};

export const getAllFilters = (formData: Model_ConfigurationQueryFilterPost) => {
  const finalOutput: TAppliedFilterChip[] = [];
  if (formData.attributes) {
    const result = formData.attributes?.reduce((acc, attribute) => {
      attribute.values?.forEach(attributeValue => {
        if (attribute.id && attribute.name && attributeValue.id && attributeValue.description) {
          acc.push({
            attributeId: attribute.id,
            attributeName: attribute.name,
            valueId: attributeValue.id,
            valueDescription: attributeValue.description
          });
        }
      });
      return acc;
    }, [] as TAppliedFilterChip[]);
    finalOutput.push(...result);
  }
  if (formData.labels) {
    const result = formData.labels?.reduce((acc, label) => {
      if (label.id && label.description) {
        acc.push({
          valueId: label.id,
          valueDescription: label.description
        });
      }
      return acc;
    }, [] as TAppliedFilterChip[]);
    finalOutput.push(...result);
  }
  return finalOutput;
};
